// export const BASE_URL = 'http://localhost:9999/api'
// export const BASE_URL = 'https://q8snxvdwgj.us-west-2.awsapprunner.com/api'
export const BASE_URL = "https://rxcarepharmacy.ca/api/api";
// export const BASE_URL = "http://62.72.3.159:3000/api";
